var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.727,
    height: 18.727,
    viewBox: "0 0 18.727 18.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(-39.041 -14.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(4 -4.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    "data-name": "Line 31",
    d: "M8.137.727H-.137A.863.863,0,0,1-1-.137.863.863,0,0,1-.137-1H8.137A.863.863,0,0,1,9-.137.863.863,0,0,1,8.137.727Z",
    transform: "translate(40.405 28.946)",
    fill: "#157fee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_31-2",
    "data-name": "Line 31",
    d: "M9.137,1.727H.863A.863.863,0,1,1,.863,0H9.137a.863.863,0,1,1,0,1.727Z",
    transform: "translate(45.268 23.81) rotate(90)",
    fill: "#157fee"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M21.227,12.864A8.364,8.364,0,1,1,12.864,4.5",
    transform: "translate(35.541 11.136)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeviceIcon);
export default __webpack_public_path__ + "static/media/addDeviceIcon.4cc6319fb85a63acb5c5f27c39808b35.svg";
export { ForwardRef as ReactComponent };